import { useState } from "react";
import FeedbackModal from "../pages/Feedback";
import "./FeedbackTab.css";

export default function FeedbackTab() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        aria-label="Open feedback"
        onClick={() => setOpen(true)}
        className="feedback-tab-button"
      >
        + Feedback
      </button>
      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
